import { WidgetViews } from '@/types'
import useWidgetOptions from '../widget-options/useWidgetOptions'
import useWidgetViewManager from '../widget-view-manager/useWidgetViewManager'
import { computed } from 'vue'
import type { View } from '../view-manager/types'

const VIEWS_WITHOUT_CLOSE_BUTTON: View[] = [
    WidgetViews.CLOSE_WIDGET,
    WidgetViews.ERROR,
]

function useCloseWidgetButton() {
    const { changeView, currentView } = useWidgetViewManager()
    const { options } = useWidgetOptions()

    const widgetCloseButtonAvailable = computed(() => {
        const { inline, showCloseButton } = options.value

        // BC
        if (
            !inline &&
            typeof showCloseButton === 'undefined' &&
            !VIEWS_WITHOUT_CLOSE_BUTTON.includes(currentView.value) &&
            currentView.value !== WidgetViews.CLOSE_WIDGET
        ) {
            return true
        }

        if (inline || VIEWS_WITHOUT_CLOSE_BUTTON.includes(currentView.value)) {
            return false
        }

        return showCloseButton
    })

    const closeWidget = () => {
        if (options.value.customPagePreview) {
            return
        }

        changeView(WidgetViews.CLOSE_WIDGET)
    }

    return {
        widgetCloseButtonAvailable,
        closeWidget,
    }
}

export default useCloseWidgetButton
